export default __webpack_public_path__ + "static/media/logo.09970563.png";